module.exports = require('./register')().Promise



//////////////////
// WEBPACK FOOTER
// ./~/any-promise/index.js
// module id = 173
// module chunks = 0